<template lang="html">

  <article class="container-comment flex wrap">
    <div class="comment">
      <p class="name" v-html="data.nombre"></p>
      <p class="date">{{data.fecha | dateToHuman}}</p>
      <p v-html="data.texto"></p>
    </div>
  </article>

</template>

<script lang="js">

  export default  {
    name: 'comentario-el',
    props: ['data'],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    filters : {
      dateToHuman: function (value) {
        let date = new Date(value*1000);
        let dateString = `${date.getDate()}-${date.getMonth()}-${date.getFullYear()}`;
        return dateString;
      }
    }
  }
</script>

<style scoped>
.comentario-el {

}
</style>



// WEBPACK FOOTER //
// src/components/view-parts/ficha-blog/comentario-el.vue